import dayjs from "dayjs"
import { useMemo } from "react"
import type { UseQueryExecute } from "urql"
import { useQuery } from "urql"

import type { GetFileInfoQuery, GetFileInfoQueryVariables, SignedUrl } from "@/graphql/codegen/graphql"
import { FieldGroupEnum, GetFileInfoDocument, ReferenceTableName } from "@/graphql/codegen/graphql"

interface UseInstructionFileUploadProps {
  instructionId: string
}
interface UseInstructionFileUploadReturn {
  fileData: SignedUrl[]
  refetchFileUploadData: UseQueryExecute
}

export const useInstructionFileUpload = ({
  instructionId,
}: UseInstructionFileUploadProps): UseInstructionFileUploadReturn => {
  const [{ data: fileUploadData }, refetchFileUploadData] = useQuery<GetFileInfoQuery, GetFileInfoQueryVariables>({
    query: GetFileInfoDocument,
    variables: {
      fileInfoInput: {
        referenceTableName: ReferenceTableName.Instruction,
        referenceId: instructionId,
        fieldGroups: [FieldGroupEnum.Instruction],
      },
    },
  })

  const fileData = useMemo(() => {
    if (!fileUploadData) return []

    if (fileUploadData.fileUpload.getFileInfo.__typename === "GetFileInfoFailure") {
      return []
    }

    return fileUploadData.fileUpload.getFileInfo.signedUrls.sort((a, b) => {
      const aDate = dayjs(a.file?.createdOn)
      const bDate = dayjs(b.file?.createdOn)
      return bDate.diff(aDate) // Sort descending (newest first)
    })
  }, [fileUploadData])

  return {
    fileData,
    refetchFileUploadData,
  }
}
